module.exports = __webpack_public_path__ + "static/img/local_image_placeholder.334d1f90.jpg";